import { capitalizeString } from '@domain-group/javascript-utils'

import { Box, DashboardModule, Image, Text } from '@domain-group/suit-theme'

import { generateLogoUrl } from '@functions/adAccount'

import type { AdAccountGroupAdAccountModel } from '@models/types'

import AdAccountListItem from './AdAccountListItem'

type CategoryTitle = 'facebook' | 'google'

interface CustomHeaderProps {
  categoryTitle: CategoryTitle,
}

const CustomHeader = (props: CustomHeaderProps) => {
  const { categoryTitle } = props

  const logoUrl = generateLogoUrl(categoryTitle)

  return (
    <Box borderBottom="1px solid" borderColor="lineColor">
      <Box borderRight="1px solid" borderColor="lineColor" padding="large" width="fit-content">
        <Image backgroundSize="contain" height="32px" width="120px" url={logoUrl} />
      </Box>

      <Box flexDirection="column" justifyContent="center" padding="large">
        <Text fontSize="small">{capitalizeString(categoryTitle)}</Text>
      </Box>
    </Box>
  )
}

type AdAccountsModuleProps = {
  adAccountGroupAdAccounts: AdAccountGroupAdAccountModel[],
  categoryTitle: CategoryTitle,
}

const AdAccountsModule = (props: AdAccountsModuleProps) => {
  const { adAccountGroupAdAccounts, categoryTitle } = props

  return (
    <DashboardModule customHeader={<CustomHeader categoryTitle={categoryTitle} />}>
      <Box flexDirection="column">
        {adAccountGroupAdAccounts.map(adAccountGroupAdAccount => (
          <AdAccountListItem adAccountGroupAdAccount={adAccountGroupAdAccount} key={adAccountGroupAdAccount.id} />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default AdAccountsModule